export default __webpack_public_path__ + "static/media/Summoner's Straps of Prestige.1afedd48.jpg";